/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import EmptyProduct from '../EmptyProductConnector';
import ItemDetails from '../ItemDetails';
import { ItemActionsBar } from '../ItemActionsBar';
import ExpandToggle from '../ExpandToggleConnector';
import ItemMessage from '../ItemMessage';
import FlagWindowWarning from '../FlagWindowWarningConnector';
import ItemProduct from '../ItemProductConnector';
import InstallationItemActionsBar from '../ItemActionsBar/InstallationItemActionsBar';
import WindowFlagNotes from '../WindowFlagNotesConnector';
import WindowNotes from '../WindowNotesConnector';

import { FlexFill } from './styles';

const ItemCard = ({
  itemId,
  isCopyStylesValid,
  isCopyStylesErrorMsg,
  itemIndex,
  hasProduct,
  isLockedOrOrdered,
  invalid,
  isDiscontinued,
  isCustomerViewingCustomProduct,
  isMandi,
  isAutoReleaseDesign,
  isInternalUser,
  isFlagged,
  hasNotes,
  flaggedWindowText,
  itemCardBannerClass,
}) => {
  const showItemActionsBar = isMandi
    ? hasProduct && (isInternalUser || !isFlagged)
    : !isLockedOrOrdered;

  const showEmptyItemProduct = isMandi
    ? !hasProduct && (isInternalUser || !isFlagged)
    : !hasProduct;

  const messageProps = {
    isCustomerViewingCustomProduct, isMandi, invalid, isDiscontinued, isCopyStylesValid,
  };

  return (
    <div className={cn(['itemCard', (invalid || isDiscontinued) && 'invalid', itemCardBannerClass])} key={`item-${itemId}`}>
      <ItemDetails itemId={itemId} itemIndex={itemIndex} />
      <div id="productDetails">
        <ItemMessage {...messageProps} isCopyStylesErrorMsg={isCopyStylesErrorMsg} />
        <div className="itemHeader">
          {showItemActionsBar &&
            <ItemActionsBar
              itemId={itemId}
              isCustomerViewingCustomProduct={isCustomerViewingCustomProduct}
            />
          }
          {hasProduct &&
            <ExpandToggle itemId={itemId} />
          }
        </div>
        {hasProduct && (
          <ItemProduct itemId={itemId} />
        )}
        {showEmptyItemProduct &&
          <EmptyProduct itemId={itemId} />
        }
        {isMandi && isFlagged && !isInternalUser &&
          <FlagWindowWarning flaggedWindowText={flaggedWindowText} />
        }
        {isMandi && isInternalUser && isFlagged &&
          <WindowFlagNotes itemId={itemId} />
        }
        {isMandi && isInternalUser && hasNotes &&
          <WindowNotes itemId={itemId} />
        }
        <FlexFill />
        {!isAutoReleaseDesign && isMandi && hasProduct && (
          <InstallationItemActionsBar itemId={itemId} />
        )}
      </div>
    </div>
  );
};

ItemCard.defaultProps = {
  invalid: false,
  isDiscontinued: false,
  isLockedOrOrdered: false,
  isInternalUser: false,
  isFlagged: false,
  hasNotes: false,
  flaggedWindowText: '',
  itemCardBannerClass: '',
  isCopyStylesErrorMsg: false,
};

ItemCard.propTypes = {
  designId: PropTypes.string.isRequired,
  hasProduct: PropTypes.bool.isRequired,
  itemId: PropTypes.string.isRequired,
  itemIndex: PropTypes.number.isRequired,
  invalid: PropTypes.bool,
  isDiscontinued: PropTypes.bool,
  isLockedOrOrdered: PropTypes.bool,
  isCustomerViewingCustomProduct: PropTypes.bool.isRequired,
  isMandi: PropTypes.bool.isRequired,
  isAutoReleaseDesign: PropTypes.bool.isRequired,
  isFlagged: PropTypes.bool,
  isCopyStylesValid: PropTypes.bool.isRequired,
  isCopyStylesErrorMsg: PropTypes.bool,
  isInternalUser: PropTypes.bool,
  hasNotes: PropTypes.bool,
  flaggedWindowText: PropTypes.string,
  itemCardBannerClass: PropTypes.string,
};

export default ItemCard;
